import "./App.css";

import Profile from "./Pages/Index";
import NotFound from "./Pages/NotFound";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Menu from "./Pages/Menu";
import Landscapes from "./Pages/Landscapes";
import Portraits from "./Pages/Portraits";
import Street from "./Pages/Street";
import Travel from "./Pages/Travels";
import Contact from "./Pages/Contact";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Profile />} />
        <Route exact path="/menu" element={<Menu />} />
        <Route exact path="/code" element={<Profile />} />
        <Route exact path="/landscapes" element={<Landscapes />} />
        <Route exact path="/portraits" element={<Portraits />} />
        <Route exact path="/moments" element={<Street />} />
        <Route exact path="/travels" element={<Travel />} />
        <Route path="/contact" element={<Contact />} />
        {/* <Route exact path="/photography/about" element={<About />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
